document.addEventListener('DOMContentLoaded', () => {
    const subscriptionForms = document.querySelectorAll('form.subscribe-form');

    if (!subscriptionForms.length) return;

    const siteKey = document.querySelector('meta[name="recaptcha-site-key"]')?.content?.trim() || '';

    let recaptchaLoading = null;

    const loadRecaptcha = () => {
        if (!siteKey) {
            return Promise.reject(new Error('Missing reCAPTCHA site key'));
        }

        if (window.grecaptcha && typeof window.grecaptcha.execute === 'function') {
            return Promise.resolve();
        }

        if (recaptchaLoading) {
            return recaptchaLoading;
        }

        recaptchaLoading = new Promise((resolve, reject) => {
            const existing = document.querySelector('script[data-recaptcha-api]');

            if (existing) {
                existing.addEventListener('load', () => {
                    if (window.grecaptcha?.ready) {
                        window.grecaptcha.ready(resolve);
                    } else {
                        resolve();
                    }
                });
                existing.addEventListener('error', reject);

                return;
            }

            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
            script.async = true;
            script.dataset.recaptchaApi = '1';
            script.onload = () => {
                if (window.grecaptcha?.ready) {
                    window.grecaptcha.ready(resolve);
                } else {
                    resolve();
                }
            };
            script.onerror = reject;
            document.head.appendChild(script);
        });

        return recaptchaLoading;
    };

    subscriptionForms.forEach((form) => {
        form.addEventListener('focusin', () => {
            loadRecaptcha().catch(() => {});
        }, { once: true });

        form.addEventListener('submit', async (event) => {
            event.preventDefault();

            const formEl = event.target;
            const formData = new FormData(formEl);

            try {
                await loadRecaptcha();
                await new Promise((resolve) => {
                    window.grecaptcha.ready(resolve);
                });

                const token = await window.grecaptcha.execute(siteKey, {
                    action: 'newsletter_subscribe',
                });

                formData.set('recaptcha_token', token);

                const response = await axios.post('/newsletter/subscribe', formData);

                Swal.fire(
                    'Subscribed!',
                    response.data.message || 'Please check your email to confirm your subscription.',
                    'success'
                );

                formEl.reset();
            } catch (error) {
                let message = 'Something went wrong. Please try again later.';

                if (error.response?.status === 429) {
                    message = 'Too many attempts. Please wait a minute and try again.';
                } else if (error.response?.data?.errors?.recaptcha_token?.[0]) {
                    message = error.response.data.errors.recaptcha_token[0];
                } else if (error.response?.data?.message) {
                    message = error.response.data.message;
                } else if (error.response?.data?.errors?.email?.[0]) {
                    message = error.response.data.errors.email[0];
                }

                Swal.fire('Error', message, 'error');
            }
        });
    });
});
